import React from "react";
import { CustomIconButton } from "../../buttons";
import { icon } from "../../icon-component";
import styles from "./SideDrawerMain.module.css";
import Resizer from "../../resizer/Resizer";

export default function SideDrawerMain({
	drawerClassName = "",
	DrawerComponent,
	DrawerHeader = null,
	children,
	className = "",
	contentClassName = "",
	onOpenDrawer = null,
	openDrawer = false,
	wildCardClassName = "",
	wildcard = null,
	iconButton = null,
	tooltip = "",
	...props
}) {
	return (
		<div className={`${styles.layout} ${className}`} {...props}>
			{typeof onOpenDrawer === "function" ? (
				<div className={`${styles.layout__drawer} ${drawerClassName}`} data-open={openDrawer}>
					{openDrawer && wildcard && <div className={wildCardClassName}>{wildcard()}</div>}
					<div className={styles.drawer__header}>
						<CustomIconButton
							className={styles.drawer__iconBtn}
							icon={(openDrawer && icon.faChevronLeft) || iconButton || icon.faBars}
							size="sm"
							tooltip={tooltip}
							variant="outlined"
							onClick={onOpenDrawer}
						/>
						{openDrawer && DrawerHeader && <DrawerHeader />}
					</div>
					{openDrawer && <DrawerComponent {...props} />}
				</div>
			) : (
				<div data-open className={styles.layout__drawer}>
					<DrawerComponent {...props} />
				</div>
			)}
			<Resizer active={openDrawer} className={styles.resizer} max={30} min={20} />
			<div className={`${styles.layout__main} ${contentClassName}`}>{children}</div>
		</div>
	);
}
